//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { BASE_URL, USER_TYPE_JS } from '../../common/constants';
// , GO_TO_MY_DASHBOARD

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdButton from '../../common/elemental/AfitdButton';
// import AfitdLink from '../../common/elemental/AfitdLink';
import CheckIcon from '@material-ui/icons/Check';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    mainContainer: { display: 'flex', justifyContent: 'center' },
    root: { marginTop: 50 },
    Button: { marginTop: 40, minWidth: 300 },
    title: { fontWeight: 'bold', fontSize: 26, marginTop: 40, marginBottom: 16 },
    message: { textAlign: 'center' },
    content: { textAlign: 'center' },
    mainIcon: { fontSize: 93, color: 'rgba(216, 216, 216, 1)' },
    secondIcon: { background: '#FC821F', color: '#fff', borderRadius: '50%', fontSize: 93, padding: 2 },
    iconContainer: { display: 'flex', justifyContent: 'center' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, handleFinishedButton } = params;

    const defns = {
        root: { container: true, justify: 'center' },
        content: { item: true, xl: 10, lg: 10, md: 10, sm: 11, xs: 11 },
        title: { variant: 'h5', clsSkinnyBold: true },
        message: { variant: 'body1' },
        Button: {
            variant: 'contained',
            color: 'secondary',
            label: 'Finished',
            onClick: handleFinishedButton,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const SurveySuccess = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const appContext = useContext(AppContext);
    // const context = useContext(LayoutContext);

    const { currentUser } = appContext;
    const isJs = _get(currentUser, 'type') === USER_TYPE_JS;

    const history = useHistory();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleFinishedButton = async () => {
        history.push(`${BASE_URL}`);
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, isJs, handleFinishedButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.mainContainer}>
            <Grid {...defns.root}>
                <Grid {...defns.content}>
                    <div {...defns.iconContainer}>
                        <CheckIcon {...defns.secondIcon} />
                    </div>
                    <AfitdTypography {...defns.title}>Thank you!</AfitdTypography>
                    <AfitdTypography {...defns.message}>We sincerely appreciate your feedback.</AfitdTypography>
                    <AfitdTypography {...defns.message}>We will certainly consider your input towards making this platform better.</AfitdTypography>
                    <AfitdButton {...defns.Button} />
                </Grid>
            </Grid>
        </div>
    );
};

export default SurveySuccess;
